import React from "react";

type ProgressControlsProps = {
  canGoBack: boolean;
  canGoNext: boolean;
  currentPosition: number;
  totalScenes: number;
  onBack: () => void;
  onNext: () => void;
  onRestart: () => void;
};

export function ProgressControls({
  canGoBack,
  canGoNext,
  currentPosition,
  totalScenes,
  onBack,
  onNext,
  onRestart,
}: ProgressControlsProps) {
  return (
    <div className="story-controls" aria-label="Story controls">
      <button
        className="story-control-button"
        type="button"
        onClick={onBack}
        disabled={!canGoBack}
      >
        上一頁
      </button>
      <div className="story-progress" aria-live="polite">
        {currentPosition} / {totalScenes}
      </div>
      <button className="story-control-button" type="button" onClick={onRestart}>
        重新開始
      </button>
      <button
        className="story-control-button"
        type="button"
        onClick={onNext}
        disabled={!canGoNext}
      >
        下一頁
      </button>
    </div>
  );
}
